/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    export class TeamDetailDialog extends NoboxEntityDialog<UserRow, any> {
        protected getFormKey() { return TeamDetailForm.formKey; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getNameProperty() { return UserRow.nameProperty; }
        protected getService() { return UserService.baseUrl; }
        protected getDeletePermission() { return UserRow.deletePermission; }
        protected getInsertPermission() { return UserRow.insertPermission; }
        protected getUpdatePermission() { return UserRow.updatePermission; }

        protected form = new TeamDetailForm(this.idPrefix);

        constructor() {
            super();

            var $this = this;
        }

        protected updateTitle() {
            this.dialogTitle = "Detail Member" + " (" + this.get_entity().DisplayName + ")";
        }

        protected getToolbarButtons() {
            return [];
        }

    }
}